module.exports = __webpack_public_path__ + "static/media/sqsSa_sm2.7961b1fc.png";